import { clsx } from "clsx";
import { FieldValues, FieldErrors, UseFormRegister, RegisterOptions } from "react-hook-form";
import "./NicheInputField.scss";

interface INicheInputFieldProps {
  id: "name" | "description" | "rules";
  label: string;
  register: UseFormRegister<{ name: string; description: string; rules: string }>;
  errors: FieldErrors<FieldValues>;
  placeholder?: string;
  validation: RegisterOptions<{ name: string; description: string; rules: string }>;
  type?: string;
  rows?: number;
  disabled?: boolean;
}

export const NicheInputField: React.FC<INicheInputFieldProps> = ({
  label,
  id,
  register,
  errors,
  // errorMessage,
  validation,
  type,
  ...props
}) => {
  const Element = !type ? "textarea" : "input";

  return (
    <div className={clsx("NicheInputField", errors[id] && "NicheInputField_WithError")}>
      <label className="NicheInputField-Label" htmlFor={id}>
        {label}
        <Element
          {...register(id, validation)}
          id={id}
          className="NicheInputField-Input"
          type={type}
          {...props}
        />
      </label>
      {errors[id] && <p>{errors[id]?.message as string}</p>}
    </div>
  );
};
